import type { CauseCount } from './utils';
import { fmtInt } from './utils';
import { causeMeta } from './errorCatalog';
import s from './BroadcastDetailsModal.module.css';

/** Barra empilhada com a proporção de cada causa + causa principal em texto. */
export function CauseMix({ errs, active, small }: { errs: CauseCount[]; active: string | null; small?: boolean }) {
  const list = errs.filter((e) => e.n > 0).sort((a, b) => b.n - a.n);
  const sum = list.reduce((a, e) => a + e.n, 0) || 1;
  const onlyNoLead = !list.length && errs.some((e) => e.key === 'sem_lead_elegivel');
  const top = list[0];
  const tip = list.map((e) => `${fmtInt(e.n)} — ${causeMeta(e.key, e.message).description}`).join('\n');
  return (
    <div className={s.mix} title={tip}>
      <div className={s.mixBar} style={{ height: small ? 6 : 8 }}>
        {list.map((e) => (
          <div key={e.key} style={{ width: `${(e.n / sum) * 100}%`, background: causeMeta(e.key).color, opacity: !active || active === e.key ? 1 : 0.2 }} />
        ))}
      </div>
      <span className={s.mixTop}>
        {top ? `${causeMeta(top.key, top.message).label} ${fmtInt(top.n)}${list.length > 1 ? ` · +${list.length - 1}` : ''}` : onlyNoLead ? 'Sem lead elegível' : '—'}
      </span>
    </div>
  );
}
